import { memo, useMemo } from "react";
import { RichMessageRenderer } from "@/components/RichMessageRenderer";
import { splitIntoSegments } from "@/hooks/useVoiceSync";

type Props = {
  content: string;
  currentSegmentIndex: number;
  isVoicePlaying: boolean;
};

const SyncedMessageRenderer = memo(({ content, currentSegmentIndex, isVoicePlaying }: Props) => {
  const segments = useMemo(() => splitIntoSegments(content), [content]);
  const currentSeg = isVoicePlaying && currentSegmentIndex >= 0 ? segments[currentSegmentIndex] : null;

  // If no active segment, render normally
  if (!currentSeg) {
    return <RichMessageRenderer content={content} />;
  }

  return (
    <div className="synced-message-container relative">
      <RichMessageRenderer content={content} />
      {/* Pulsing left bar indicating active voice */}
      <div className="absolute -left-3 top-0 bottom-0 w-[3px] rounded-full bg-primary/40 animate-pulse" />
    </div>
  );
});

SyncedMessageRenderer.displayName = "SyncedMessageRenderer";

export default SyncedMessageRenderer;
